import React from 'react';
import './css/index.scss';
import SearchInput from '../SearchInput';
import TableHeader from '../TableHeader';
import TablePagination from '../TablePagination';
import useComponentVisible from '../../helpers/hooks/useComponentVisible';
import MyButton from '../MyButton';
import MyCheckbox from '../MyCheckbox';
import MyLoading from '../MyLoading';

function MyTable({
  perPage,
  setPerPage,
  filters = [],
  filtersCount,
  selectedFilter,
  setSelectedFilter,
  q,
  setQ,
  headerColumns,
  Item,
  data,
  page,
  setPage,
  total,
  isSecondaryStyle,
  onSearch,
  isLoading,
  onCancelSearch,
  WhileSelectingComponents,
  hideSearch = false,
  extraFilters,
  deepSearch,
  setDeepSearch,
  showDeepSearch = false,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const handlePerPage = (val) => () => {
    setPerPage(val);
    setIsComponentVisible(false);
  };

  return (
    <div className="table_wrapper">
      <div className="table_top_row">
        {!isSecondaryStyle && (
        <div className="per_page">
          <p className="per_page_text">Отображать</p>
          <div
            className="dropdown_button"
            onClick={() => setIsComponentVisible(true)}
          >
            <span>{perPage}</span>
          </div>
          <div ref={ref} className={`dropdown_wrapper ${isComponentVisible && 'visible'}`}>
            <div className="dropdown_item" onClick={handlePerPage(100)}><span>100</span></div>
            <div className="dropdown_item" onClick={handlePerPage(250)}><span>250</span></div>
            <div className="dropdown_item" onClick={handlePerPage(500)}><span>500</span></div>
          </div>
        </div>
        )}
      </div>

      <div className={`table_filters_block ${isSecondaryStyle ? 'table_filters_block_second' : ''}`}>
        <div className="table_filters_left">
          {extraFilters ? (
            <div className="table_extra_filters">
              {extraFilters}
            </div>
          ) : null}

          {Boolean(filters?.length) && (
          <div>
            <div className="table_filters_row">
              {filters.map((filter) => (
                <div
                  key={filter.id}
                  onClick={() => setSelectedFilter(filter)}
                  className={`filter_item ${selectedFilter?.id === filter.id ? 'selected' : ''}`}
                >
                  {filter.name}
                  {filtersCount && <span className="filter_item_count">{filtersCount[filter.id]}</span>}
                </div>
              ))}
            </div>
              {WhileSelectingComponents && <WhileSelectingComponents />}
          </div>
          )}
        </div>

        {isSecondaryStyle && (
        <div className="per_page">
          <p className="per_page_text">Отображать</p>
          <div
            className="dropdown_button"
            onClick={() => setIsComponentVisible(true)}
          >
            <span>{perPage}</span>
          </div>
          <div ref={ref} className={`dropdown_wrapper ${isComponentVisible && 'visible'}`}>
            <div className="dropdown_item" onClick={handlePerPage(100)}><span>100</span></div>
            <div className="dropdown_item" onClick={handlePerPage(250)}><span>250</span></div>
            <div className="dropdown_item" onClick={handlePerPage(500)}><span>500</span></div>
          </div>
        </div>
        )}

        {!hideSearch && (
          onSearch ? (
            <div className="table_search_block">
              <div className="table_search_row">
                <SearchInput value={q} onChange={setQ} placeholder="Поиск" disabled={isLoading} />
                <MyButton
                  text={isLoading ? 'Прекратить' : 'Искать'}
                  onClick={isLoading ? onCancelSearch : onSearch}
                  secondary={isLoading}
                  className="table_search_button"
                />
              </div>
              {(showDeepSearch || isLoading) ? (
                <div className="table_search_below">
                  {showDeepSearch ? (
                    <MyCheckbox
                      text="Глубокий поиск"
                      setValue={setDeepSearch}
                      value={deepSearch}
                    />
                  ) : null}
                  {isLoading ? (
                    <div className="table_search_loading">
                      <p>Загрузка...</p>
                      <MyLoading strokeWidth={4} width={24} height={24} />
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          ) : (
            <SearchInput value={q} onChange={setQ} placeholder="Поиск" />
          )
        )}
      </div>

      {headerColumns?.length ? (
        <TableHeader columns={headerColumns} />
      ) : <div style={{ height: '40px' }} /> }
      <div className="table_scroll">
        {data.length > 0 ? (
          data.map(Item)
        ) : (
          <p className="table_scroll_text">Нет результатов по данному запросу</p>
        )}
      </div>

      <TablePagination
        page={page}
        setPage={setPage}
        pagesCount={perPage && isFinite(perPage) ? Math.ceil(total / perPage) : 1}
      />
    </div>
  );
}

export default MyTable;
